import React from "react";
import {Address} from "../redux/types";
import {OrderAddress} from "../features/orders/redux/types";

const getEmptyName = (): OrderAddress["name"] => ({
    firstName: "",
    lastName: "",
    salutation: "Herr",
    companyName: ""
});

export const getEmptyOrderAddress = (): OrderAddress => ({
    address: undefined as unknown as Address,
    name: getEmptyName(),
    phone: ""
});

type OrderAddressFormStateType = [
    OrderAddress | undefined,
    (a: Address) => void,
    (name: OrderAddress["name"], phone: string) => void,
    () => void
]

export function useOrderAddressFormState(initialState?: OrderAddress): OrderAddressFormStateType {
    const [orderAddress, setOrderAddress] = React.useState<OrderAddress | undefined>(initialState);

    const setAddress = (address: Address) => setOrderAddress(old => old
        ? ({
            ...old,
            address
        })
        : ({
            ...getEmptyOrderAddress(),
            address
        }));

    const setName = (name: OrderAddress["name"], phone: string) => setOrderAddress(old => old
        ? ({
            ...old,
            name,
            phone
        })
        : ({
            ...getEmptyOrderAddress(),
            name,
            phone
        }));

    const clearValues = () => setOrderAddress(undefined);

    return ([orderAddress, setAddress, setName, clearValues])
}

